import "./banner/Banner.css";
import Banner from "./banner/Banner";
import {
  faBars,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popular_Product from "./popular_product/Popular_Product";
import "./Home.css";
import Explore_By_Category from "./explore_by_category/Explore_By_Category";
import Offers_Slider from "./offers_slider/Offers_Slider";
import Common_Product_Swiper from "../common_components/common_product_swiper/Common_Product_Swiper";
import Green_Btn from "../common_components/common_btn/green_btn/Green_Btn";
import { useEffect, useState } from "react";
import Banner_Btn_Component from "./banner_btn_component/Banner_Btn_Component";
import Offer_Banner from "./offer_banner/Offer_Banner";
import New_In_Store from "./new_in_store/New_In_Store";
import Offer_Products from "./offer_products/Offer_Products";
import { useNavigate } from "react-router-dom";
import {
  getAddBanner,
  getCoupons,
  getOfferProduct,
} from "../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getGroupByProduct } from "../../features/products/productsSlice";

function Home() {
  const dispatch = useDispatch();
  const [categoryId, setCategoryId] = useState();

  const coupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons(100));
  }, []);

  const data1 = [
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
  ];

  const data2 = [
    {
      img: "/assets/images/products/img3.png",
      label: "Chips",
    },
    {
      img: "/assets/images/products/img4.png",
      label: "Cold Drinks and Juices",
    },
    {
      img: "/assets/images/products/img5.png",
      label: "Ice Cream and Frozen Desserts",
    },
    {
      img: "/assets/images/products/img3.png",
      label: "Chips",
    },
    {
      img: "/assets/images/products/img4.png",
      label: "Cold Drinks and Juices",
    },
    {
      img: "/assets/images/products/img5.png",
      label: "Ice Cream and Frozen Desserts",
    },
  ];

  const [showMore, setShowMore] = useState(false);

  const navigate = useNavigate();

  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup
  );

  useEffect(() => {
    dispatch(getGroupByProduct({}));
  }, [dispatch]);

  const addBanners = useSelector((state) => state.home.addBanners);

  useEffect(() => {
    dispatch(getAddBanner());
  }, [dispatch]);
  return (
    <section className="Home">
      <div className="container">
        <div className="desktop_view">
          <div className="row me-0 ms-0 ">
            <div className="col-xxl-2 col-xl-3 col-lg-3">
              <div className="row justify-content-between custom_row me-0 ms-0">
                <div className="col-lg-12 col-sm-6">
                  <div className="cat_div">
                    <button
                      className="cat_btn"
                      type="button"
                      onClick={() => {
                        navigate("/shop");
                      }}
                    >
                      <div className="left_side">
                        <div className="icon_holder">
                          <img
                            src="/assets/images/popular_products/bars.png"
                            className="bar_img"
                          />
                          <img
                            src="/assets/images/popular_products/bar_sort.png"
                            className="sort_bar_img"
                          />
                        </div>

                        <p className="btn_text">Categories</p>
                      </div>

                      {/* <div className="right_side">
                        <FontAwesomeIcon icon={faSortDown} className="icon" />
                      </div> */}
                    </button>
                  </div>

                  <div className="popular_prod">
                    <Popular_Product />
                  </div>
                </div>

                {/* {addBanners?.[0]?.image ? (
                  <div className="col-lg-12 col-sm-4">
                    <section className="Offer_Card">
                      <div className="img_holder">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL + addBanners[0]?.image
                          }
                          // src="/assets/images/home/offfer/offer.png"
                          className="offer_img"
                        />
                      </div>
                    </section>
                  </div>
                ) : null} */}
              </div>
            </div>
            <div className="col-xxl-10 col-xl-9 col-lg-9">
              <div className="body_container">
                <Banner />
                <Explore_By_Category
                  categoryId={categoryId}
                  setCategoryId={setCategoryId}
                />

                {coupons?.data?.length > 0 && (
                  <Offers_Slider coupons={coupons} />
                )}

                {categoryWiseProduct?.data?.slice(0, 3)?.map((val) => (
                  <div className="grocery_div" key={val.id}>
                    <Common_Product_Swiper
                      multiple="Multiple"
                      data={val}
                      background_color={val?.background_color}
                      button_color={val?.button_color}
                      headingText={val?.name}
                    />
                  </div>
                ))}
                {categoryWiseProduct?.data?.length > 3 && (
                  <div className="show_btn_div">
                    <Green_Btn
                      btn_name={showMore ? "Show Less Categories" : "Show More Categories"}
                      rightIcon={showMore ? faSortUp :  faSortDown}
                      onClick={() => {
                        setShowMore(!showMore);
                      }}
                    />
                  </div>
                )}

                {showMore && (
                  <>
                    {categoryWiseProduct?.data?.slice(3)?.map((val) => (
                      <div className="grocery_div" key={val.id}>
                        <Common_Product_Swiper
                          multiple="Multiple"
                          data={val}
                          background_color={val?.background_color}
                          button_color={val?.button_color}
                          headingText={val?.name}
                        />
                      </div>
                    ))}
                  </>
                )}

                {addBanners?.[1]?.image ? (
                  <Banner_Btn_Component addBanners={addBanners} />
                ) : null}
                <New_In_Store />
                {/* {addBanners?.[2]?.image ? (
                  <Offer_Banner addBanners={addBanners} />
                ) : null} */}
                
                <Offer_Products  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
